module.exports = __webpack_public_path__ + "img/Naval_Ensign_of_Honduras.e9a3ceac.svg";